module.exports = "/_next/static/images/Tatiana_Leahovici-8bf158b016eb837e593ab1a6b5549755.webp";